var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGamedeveloper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "2 2 81 81",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Selection",
    d: "M 60.00,40.00 C 60.00,40.00 75.00,40.00 75.00,40.00 83.40,40.15 81.96,45.23 80.48,52.00 78.28,62.11 71.68,70.82 63.00,76.29 37.69,92.25 3.14,74.33 3.00,44.00 2.91,25.50 10.94,11.57 29.00,5.09 35.77,2.66 54.63,1.01 58.98,8.22 60.20,10.26 60.00,13.66 60.00,16.00 60.00,16.00 60.00,40.00 60.00,40.00 Z M 54.00,10.00 C 54.00,10.00 44.00,8.52 44.00,8.52 9.66,5.94 -5.27,52.29 23.00,70.89 27.86,74.09 33.26,75.65 39.00,76.23 43.96,76.73 50.36,75.93 55.00,74.07 60.21,71.99 65.10,68.35 68.62,64.00 73.30,58.22 75.39,52.31 76.00,45.00 72.91,45.00 62.83,44.42 60.69,45.99 60.69,45.99 55.78,52.98 55.78,52.98 50.83,58.74 43.45,62.01 36.00,58.99 15.75,50.79 24.71,21.13 45.00,26.00 40.40,33.20 28.78,30.30 30.11,44.00 31.29,56.09 49.46,60.25 54.00,45.00 51.87,45.00 39.77,46.03 40.62,42.17 41.29,39.13 51.48,40.00 54.00,40.00 54.00,40.00 54.00,10.00 54.00,10.00 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamedeveloper);
export default __webpack_public_path__ + "static/media/gamedeveloper.5ede948325c5fb935ba7e41c943cd65e.svg";
export { ForwardRef as ReactComponent };